import { inject, ref } from 'vue'

export function useStorefront() {
    const storefront = inject('storefront', ref({}))

    return {
        storefront
    }
}